module.exports = __webpack_public_path__ + "static/media/corner-down-right-alt.5ddf2c81.svg";